export default __webpack_public_path__ + "static/media/Coin Icon.dac00261.svg";